import React, { PropsWithChildren } from "react";
//#region types
import { EntityCreationLayoutProps } from "models/propTypes/pageLayoutPropTypes";
import { HTMLConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const EntityCreationLayout: React.FC<PropsWithChildren<EntityCreationLayoutProps>> = (props) => {
  return (
    <Grid container className={clsx(cssExports.entityCreationLayout, props.className)}>
      <Grid item container spacing={2} className={cssExports.upperContainer}>
        {props.upperLeftComponent ? (
          <Grid
            id={`${props.layoutKey ?? ""}${HTMLConstants.EntityCreationLayoutUpperLeftPortalId}`}
            item
            container
            md={3}
            className={cssExports.upperLeftContainer}
          >
            {props.upperLeftComponent}
          </Grid>
        ) : (
          <></>
        )}
        <Grid
          item
          container
          md={9}
          direction="column"
          justifyContent="flex-end"
          className={cssExports.upperRightContainer}
        >
          {props.upperRightComponent}
        </Grid>
      </Grid>
      <Grid item container spacing={3} className={cssExports.lowerContainer}>
        {props.lowerLeftComponent ? (
          <Grid
            id={`${props.layoutKey ?? ""}${HTMLConstants.EntityCreationLayoutLowerLeftPortalId}`}
            item
            container
            md={3}
            className={cssExports.lowerLeftContainer}
          >
            {props.lowerLeftComponent}
          </Grid>
        ) : (
          <></>
        )}
        <Grid
          item
          container
          md={props.lowerLeftComponent ? 9 : 12}
          direction="column"
          className={cssExports.viewPanelItemContainer}
        >
          {props.children}
          <Grid
            id={`${props.layoutKey ?? ""}${HTMLConstants.EntityCreationLayoutFooterPortalId}`}
            container
            item
            className={cssExports.footerContainer}
          >
            {props.footer}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EntityCreationLayout;
